// extracted by mini-css-extract-plugin
module.exports = {"card":"CTACard_card__IZ_UB","img":"CTACard_img__rxaiu","heading":"CTACard_heading__yaQzD","subheading":"CTACard_subheading__8_xBZ","button":"CTACard_button__J8VPz"};